import { elakay_API } from "../../config";

const shippoRequest = async (path, token, options = {}) => {
  const response = await fetch(`${elakay_API}${path}`, {
    ...options,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers
    }
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    return {
      error: data.error || "Shipping request failed",
      code: data.code,
      status: response.status
    };
  }
  return data;
};

export const createAddressShip = (token, info) => (
  shippoRequest("/shipping/createShippingProd", token, {
    method: "POST",
    body: JSON.stringify(info)
  })
);

export const createAddressShipCarts = (token, info) => (
  shippoRequest("/shipping/createShippingCarts", token, {
    method: "POST",
    body: JSON.stringify(info)
  })
);

export const createShippingCartsOne = (token, info) => (
  shippoRequest("/shipping/createShippingCartsOne", token, {
    method: "POST",
    body: JSON.stringify(info)
  })
);

export const createtransactionShip = (token, id, options = {}) => (
  shippoRequest(`/shipping/createtransactionShip/${encodeURIComponent(id)}`, token, {
    method: "POST",
    body: JSON.stringify(options)
  })
);

export const getTransactionShip = (token, id) => (
  shippoRequest(`/shipping/transactions/${encodeURIComponent(id)}`, token, {
    method: "GET"
  })
);

export const getShipping = (token, id) => (
  shippoRequest(`/shipping/shipments/${encodeURIComponent(id)}`, token, {
    method: "GET"
  })
);

export const createShippoTracking = (
  token,
  trackingNumber,
  metadata = "",
  carrier = "shippo",
  order = {}
) => (
  shippoRequest("/shipping/tracking", token, {
    method: "POST",
    body: JSON.stringify({
      carrier,
      tracking_number: trackingNumber,
      metadata,
      orderId: order.orderId,
      orderProductId: order.orderProductId
    })
  })
);

export const getTrackingShipping = (token, carrier, trackingNumber) => (
  shippoRequest(
    `/shipping/tracking/${encodeURIComponent(carrier)}/${encodeURIComponent(trackingNumber)}`,
    token,
    { method: "GET" }
  )
);

export const getTrackingShippingUsps = (token, trackingNumber) => (
  getTrackingShipping(token, "usps", trackingNumber)
);

export const postTrackingShipping = (
  token,
  carrier,
  trackingNumber,
  metadata = "",
  order = {}
) => (
  createShippoTracking(
    token,
    trackingNumber,
    metadata,
    carrier,
    order
  )
);

export const getTrackingUrl = (carrier, trackingNumber) => (
  `https://track.goshippo.com/tracking/${encodeURIComponent(carrier)}/${encodeURIComponent(trackingNumber)}`
);

// Order Tracking Display (Tracking Number modal -- steps/iframe/both).
// GET /shipping/tracking/order/:orderId/:orderProductId -- already
// auth-gated + ownership-checked server-side (findAuthorizedOrderItem),
// already normalizes provider statuses into the 6-step timeline. This is
// the only endpoint the modal calls; the server decides everything
// (displayMode, steps, iframeAllowed) -- no provider logic lives here.
export const getOrderTrackingAPI = (token, orderId, orderProductId) => (
  shippoRequest(
    `/shipping/tracking/order/${encodeURIComponent(orderId)}/${encodeURIComponent(orderProductId)}`,
    token,
    { method: "GET" }
  )
);

// Automatic shipping estimate (server_elakay POST /shipping/estimate). The
// token is optional: a guest gets origin/free-shipping status only.
export const getShippingEstimate = (token, { items, destination }, signal) => (
  shippoRequest("/shipping/estimate", token, {
    method: "POST",
    body: JSON.stringify({ items, destination }),
    ...(signal ? { signal } : {})
  })
);

// Internal Sale Simulation behind the shipping estimate (server_elakay POST
// /shipping/sale-simulation): costs, fees, target/actual profit and the
// destination shipping protection. The server only answers for the
// product's own Seller, its Dropshipping In Provider, or Family (403 otherwise).
export const getSaleSimulation = (token, { items, destination }, signal) => (
  shippoRequest("/shipping/sale-simulation", token, {
    method: "POST",
    body: JSON.stringify({ items, destination }),
    ...(signal ? { signal } : {})
  })
);
